export default {
  "b2b.zakaznici-grid.label": "Zákazníci"
};
